"use strict";
// NOTE
// https://stackoverflow.com/questions/34550890/how-to-detect-if-script-is-running-in-browser-or-in-node-js
Object.defineProperty(exports, "__esModule", { value: true });
exports.in_browser_p = void 0;
function in_browser_p() {
    return typeof window === "object";
}
exports.in_browser_p = in_browser_p;
//# sourceMappingURL=in-browser-p.js.map